import { Flex, Icon, Text } from '@inflearn/ds-react-next';

import {
  type ValidationStatus,
  getValidationColor,
  getValidationIcon,
} from '../../utils/validation';

interface ValidationMessageProps {
  status?: ValidationStatus;
  message: string;
}

const ValidationMessage = ({ status = 'error', message }: ValidationMessageProps) => {
  const color = getValidationColor(status);

  return (
    <Flex w="100%" align="center" gap={8}>
      <Icon icon={getValidationIcon(status)} color={color} size="md" />
      <Text size="sm" c={color}>
        {message}
      </Text>
    </Flex>
  );
};

export default ValidationMessage;
